import { TextField, Grid, Typography, Card, Box, Stack, CircularProgress, FormHelperText, Icon, Badge, Checkbox, IconButton, Tooltip } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import { useEffect, useMemo, useRef, useState } from 'react';
import MDButton from 'components/MDButton';
import defaultImage from 'assets/images/placeholder-image.png';
import CommonQuillEditor from 'common/editor';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import MDInput from 'components/MDInput';
import DeleteIcon from 'common/customIcons/delete';
import { getData } from 'utilities/common';
import { openCustomModalDialog } from '../../redux/slices/modalSlice';
import { uploadImage, openSnackbar } from '../../redux/slices/common';
import { createBlogAuthor, createMigrateAuthor, getDetailMigrateAuthors } from '../../redux/apis/blogs';
import AngleRightIcon from "common/customIcons/angle_right"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { slugRegex } from "utilities/common";

import { STILO, HYPERWOLF, HEMP } from 'utilities/constants';
const initialState = {
    image: null, // { url, alt, title, description }
    name: "",
    description: "",
    slug:""
};
export default function AddAuthorPage() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { fetchingAuthor, currentAuthor } = useSelector((state) => state.blogs);
    const [copyStatus, setCopyStatus] = useState('')
    const [isSlugTrue, setIsSlugTrue] = useState(false)

    const uploadThumbnailImage = {
        borderRadius: '12px',
        width: '100px',
        height: '100px',
        objectFit: 'cover',
        boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
    };
    const socialIcon = {
        backgroundColor: "#000 !important",
        color: "#fff !important",
        borderRadius: 20,
        minWidth: "2.75rem",
        minHeight: "2.75rem",
        transition: "background-color 0.3s ease, color 0.3s ease",
        "&:hover": {
            backgroundColor: "grey.900",
        },
    };
    console.log("fetchingAuthor", fetchingAuthor);

    const user = getData('login-user-info')
    const parseUser = user ? JSON.parse(user) : null;
    const { isUploading = false } = useSelector((state => state.common));
    const { updatingAuthor: isLoading = false } = useSelector((state => state.blogs));
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({ ...initialState, createdBy: parseUser?.name || "" });
    const uploadedImageRef = useRef(null);
    const { authorId } = useParams()
    const banner = formData;
    const adminMode = JSON.parse(localStorage.getItem('adminsMode'))
    const frontendUrl = adminMode === STILO ? process.env.REACT_APP_STILO_FRONTEND_URL : adminMode === HYPERWOLF ? process.env.REACT_APP_HYPERWOLF_FRONTEND_URL : process.env.REACT_APP_HEMP_FRONTEND_URL;
    console.log("frontendUrl", frontendUrl, adminMode);
    const handleCopyLink = () => {
        if (currentAuthor?.slug) {
            navigator.clipboard.writeText(`${frontendUrl}/author/${currentAuthor?.slug}`);
            setCopyStatus('Copied');
            setTimeout(() => setCopyStatus(''), 2000);
        }
    };

    const handleModalImage = (type, data) => {
        dispatch(openCustomModalDialog({
            modal: 'IMAGE_MODAL_SEO',
            modalData: {
                imageContent: type, data, index: undefined, fileMediaHandler
            }
        }))
    }
    const fileMediaHandler = (mediaData) => {
        setFormData((prev) => ({
            ...prev,
            image: mediaData
        }));
    }

    const validate = () => {
        const nextErrors = {};

        if (!formData?.image?.url) nextErrors.image = "Image is required";
        if (!formData?.name?.trim()) nextErrors.name = "Name is required";

        // const plainLength = (formData?.description || "").length;
        // if (!plainLength) nextErrors.description = "Description is required";
        // if (plainLength > 600) nextErrors.description = "Description must be 600 characters or less";

        return nextErrors;
    };
    console.log("formData", formData);
    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };
    const handleSlugChange = (e) => {
        setIsSlugTrue(true)
        setFormData((p) => ({ ...p, slug: slugRegex(e.target.value) }));
    };
    const handleImageUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file || isUploading) return;
        const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB     
        if (file.size > MAX_FILE_SIZE) {
            showError('Image size should not exceed 2 MB', 'error');
            return; // Exit the function if file is too large
        }

        // Validate image type
        const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
        if (!validTypes.includes(file.type)) {
            setErrors(prev => ({ ...prev, image: "Only JPG, PNG, or WEBP images are allowed." }));
            return;
        }

        uploadedImageRef.current = "authorImage";
        const body = new FormData();
        body.append("filePath", file);

        dispatch(uploadImage(body))
            .unwrap()
            .then((res) => {
                const data = {
                    alt: "",
                    title: file?.name || "",
                    description: "",
                    url: res?.fileUrl
                };
                if (res?.fileUrl) {
                    setFormData((prev) => ({ ...prev, image: data }));
                    handleModalImage("author", data);
                }
            })
            .catch(() => { });
    };

    const updateField = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
        setErrors((prev) => ({ ...prev, [key]: "" }));
    };

    const SocialMediaHandler = (socialMediaData) => {
        const { image, ...rest } = socialMediaData || {};
        const normalized = {
            ...rest,
            imageUrl: rest?.imageUrl || image?.url || ""
        };
        setFormData((prev) => ({
            ...prev,
            socialMediaLinks: [...(prev.socialMediaLinks || []), normalized]
        }));
    };

    const handleSocialMedia = () => {
        dispatch(openCustomModalDialog({
            modal: 'SOCIAL_MEDIA_UPLOAD',
            modalData: {
                socialMedia: 0,
                SocialMediaHandler
            }
        }))
    };

    const updateSocialMedia = (socialIndex, key, value) => {
        setFormData((prev) => {
            const links = [...(prev.socialMediaLinks || [])];
            links[socialIndex] = { ...(links[socialIndex] || {}), [key]: value };
            return { ...prev, socialMediaLinks: links };
        });
    };

    const removeSocialMedia = (socialIndex) => {
        setFormData((prev) => ({
            ...prev,
            socialMediaLinks: (prev.socialMediaLinks || []).filter((_, i) => i !== socialIndex)
        }));
    };
    console.log("formData", formData, authorId);

    const submitHandler = () => {
        const nextErrors = validate();
        setErrors(nextErrors);
        if (Object.keys(nextErrors).length) return;

        const normalizedSocialMediaLinks = (formData?.socialMediaLinks || []).map((item) => {
            const { image, ...rest } = item || {};
            return {
                ...rest,
                imageUrl: rest?.imageUrl || image?.url || ""
            };
        });
        // if (authorId) {
        //     delete formData?._id
        //     delete formData?.createdDate
        //     delete formData?.updatedDate

        // }
            if (isSlugTrue) {
                formData.slug = formData.slug;
            } else {
                delete formData?.slug
            }
        

        console.log("isSlugTrue", isSlugTrue, formData);

        dispatch(createMigrateAuthor({ ...formData, socialMediaLinks: normalizedSocialMediaLinks, authorId: authorId }))
            .unwrap()
            .then((res) => {
                dispatch(openSnackbar({ content: res?.message || "Author created", color: "success", icon: "check" }));
                navigate('/manages/author');
            })
            .catch((err) => {
                dispatch(openSnackbar({ content: err?.message || "Failed to create author", color: "error", icon: "warning" }));
            });
    };

    const characterCount = useMemo(() => (formData?.description || "").length, [formData?.description]);

    useEffect(() => {
        if (authorId) {
            dispatch(getDetailMigrateAuthors(authorId)).unwrap().then((res) => {
                console.log("currentAuthor res", res?.data);
                setFormData({
                    slug: res?.data?.slug,
                    image: res?.data?.image,
                    name: res?.data?.name,
                    description: res?.data?.description,
                    socialMediaLinks: res?.data?.socialMediaLinks
                })

            }).catch((err) => {
            })
        }

    }, [authorId])
    console.log("currentAuthor", currentAuthor);

    return (
        <CommonLayout>
            <Box px={4} pt={2}>
                <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={2}>
                    <Grid item xs={12} sm={2}>
                        <Box display="flex" alignItems="center" justifyContent={'space-between'}>
                            <Box display="flex" alignItems="center" color='text.main' lineHeight={1}>
                                <span style={{ cursor: 'pointer', display: "flex", alignItems: "center" }} onClick={() => { navigate('/manages/author') }}>
                                    <AngleRightIcon fontSize="14px" />
                                    <Typography variant='h6' fontWeight="semibold" ml={.75}>{authorId ? currentAuthor?.name : 'Author'}</Typography>
                                </span>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={10}>
                        <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2}>
                            <Box display="flex" alignItems="center" justifyContent="end" gap={2}>
                                {currentAuthor?.slug && (
                                    <Box
                                        display="flex"
                                        sx={{ cursor: "pointer" }}
                                        alignItems="center"
                                        color="text.main"
                                        lineHeight={1}
                                        gap={1}
                                        style={{ position: "relative" }}
                                    >
                                        <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                                            <IconButton
                                                size="small"
                                                onClick={handleCopyLink}
                                                sx={{ color: 'primary.main' }}
                                            >
                                                <ContentCopyIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>

                                        <Typography
                                            variant="body"
                                            component="a"
                                            href={`${frontendUrl}/author/${currentAuthor?.slug}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{ textDecoration: "none", color: "inherit" }}
                                            style={{
                                                borderRadius: "26px",
                                                color: "#0163FF",
                                                fontSize: "14px",
                                                fontWeight: "400",
                                                border: "1px solid #0163FF",
                                                padding: "10px 16px",
                                            }}
                                        >{`${frontendUrl}/author/${currentAuthor?.slug}`}</Typography>

                                    </Box>
                                )}

                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="end" gap={2}>
                                <MDButton
                                    sx={{ minWidth: "160px" }}
                                    type="button"
                                    variant="outlined"
                                    color="dark"
                                    className="dark-outlined-btn"
                                    disabled={isLoading || isUploading || fetchingAuthor}
                                    onClick={() => navigate('/manages/author')}
                                >
                                    Cancel
                                </MDButton>
                                <MDButton
                                    sx={{ minWidth: "160px" }}
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    disabled={isLoading || isUploading || fetchingAuthor}
                                    onClick={submitHandler}
                                >
                                    {isLoading ? "Saving..." : "Save"}
                                </MDButton>
                            </Box>
                        </Stack>
                    </Grid>

                </Grid>
            </Box>

            <Box px={{ xs: 2, sm: 3, lg: 4 }} pt={0} pb={{ xs: 2, sm: 3, lg: 4 }}>
                <Card sx={{ p: { xs: 2, md: 4 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}
                    style={{
                        borderRadius: "18px",
                        border: "1px solid #F1F1F1"
                    }}
                >
                    <Grid container spacing={3}>

                        <Grid item xs={12}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Image</Typography>
                            <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec img-upload-100">
                                <Badge
                                    overlap='circular'
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                    badgeContent={isUploading ? <CircularProgress size={32} color='primary' /> : ''}
                                >
                                    {
                                        banner?.image?.url ?
                                            <img onClick={() => handleModalImage("author", banner.image)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='author' />
                                            :
                                            <label htmlFor='author-image-upload' className='add-change-image'>
                                                <MDButton
                                                    sx={{ minWidth: '180px' }}
                                                    type='button'
                                                    variant='outlined'
                                                    color='secondary'
                                                    component='span'
                                                    disabled={isUploading}
                                                >
                                                    <div className='add-change-img-sec'>
                                                        <h5>Add Profile Image</h5>
                                                        <p>100x100</p>
                                                    </div>
                                                </MDButton>
                                            </label>
                                    }
                                </Badge>
                                {
                                    banner.image?.url &&
                                    <label htmlFor='author-image-upload' className='upload-change-image' style={{ justifyContent: "start" }}>
                                        <MDButton
                                            sx={{ minWidth: 'auto' }}
                                            type='button'
                                            variant='outlined'
                                            color='secondary'
                                            component='span'
                                            disabled={isUploading}
                                        >
                                            <div className='add-change-img-sec'>
                                                <p style={{ fontSize: "12px" }}>Change Image 100x100</p>
                                            </div>

                                        </MDButton>
                                    </label>
                                }
                                <MDInput
                                    id='author-image-upload'
                                    type='file'
                                    name='categoryImage'
                                    onChange={handleImageUpload}
                                    fullWidth
                                    disabled={isUploading}
                                    style={{ display: 'none' }}
                                />
                                {Boolean(errors?.image) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.image}</FormHelperText>}
                            </Stack>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Name</Typography>
                                    <TextField
                                        // label="Name"
                                        className="form-input"
                                        fullWidth
                                        placeholder="Name"
                                        value={banner.name}
                                        onChange={(e) => updateField('name', e.target.value)}
                                        error={Boolean(errors?.name)}
                                        helperText={errors?.name}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Slug</Typography>

                                    <TextField
                                        // label="Slug"
                                        fullWidth
                                        name="slug"
                                        value={banner.slug}
                                        onChange={handleSlugChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                            <CommonQuillEditor
                                allowHeading={false}
                                value={banner.description || ''}
                                onChange={(value) => updateField('description', value)}
                            />
                            {Boolean(errors?.description) && (
                                <FormHelperText error>{errors?.description}</FormHelperText>
                            )}
                            {/* <span className='drag_drop'>
                                Character Count: {characterCount} <span>(Max: 600)</span>
                            </span> */}
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Social Media Link</Typography>

                            {banner?.socialMediaLinks?.map((data, socialIndex) => (
                                <Box display="flex" alignItems="end" gap={1.5} mb={2} key={socialIndex}>
                                    <Checkbox
                                        sx={{ mb: 0.75 }}
                                        checked={data.status}
                                        onChange={(e) => updateSocialMedia(socialIndex, "status", e.target.checked)}
                                    />

                                    <IconButton sx={socialIcon} disabled >
                                        <img width={24} height={24} style={{ objectFit: "contain" }} src={data.imageUrl || defaultImage} />
                                    </IconButton>

                                    <Box mb="-1px" flex={1} maxWidth={260}>
                                        <Typography variant='caption' fontWeight="normal" color="#2E2E3A">{data.platform}</Typography>
                                        <div className='cta-btn'>
                                            <TextField
                                                className="form-input"
                                                fullWidth
                                                value={data.link}
                                                onChange={(e) => updateSocialMedia(socialIndex, "link", e.target.value)}
                                            />
                                        </div>
                                    </Box>

                                    <MDButton sx={{ p: 1.25, minWidth: "auto" }} color="error" size="small" variant="contained" onClick={() => removeSocialMedia(socialIndex)}>
                                        <DeleteIcon />
                                    </MDButton>


                                </Box>
                            ))}

                            <Box display="flex" alignItems="center" gap={1.5} mb={2} mt={3}>
                                <MDButton sx={{ p: 1.25, minWidth: "240px" }} color='primary' size='medium' variant='outlined' onClick={handleSocialMedia}>
                                    <Icon>add</Icon>&nbsp;Social Media Link
                                </MDButton>
                            </Box>

                        </Grid>

                    </Grid>
                </Card>
            </Box>
        </CommonLayout>
    )
}